function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--icon-color, currentColor)"
    },
    d: "M25.2412 16.9961L10.5486 31.4397C9.88457 32.1868 9.17899 32.1868 8.43191 31.4397L7.56031 30.5681C6.81323 29.904 6.81323 29.1984 7.56031 28.4514L20.2607 16L7.56031 3.54864C6.89624 2.80156 6.89624 2.09598 7.56031 1.43191L8.43191 0.560311C9.17899 -0.18677 9.88457 -0.18677 10.5486 0.560311L25.2412 15.0039C25.9053 15.668 25.9053 16.332 25.2412 16.9961Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.2b3d12f3a405888bc16913de6a250d89.svg";
export { ForwardRef as ReactComponent };